<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-27 16:23:19
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-31 16:40:37
-->
<template>
	<div>
		<div class="rich-wrap" v-html="jieshao"></div>
	</div>
</template>
<script>
export default {
	data(){
		return{
			
		}
	},
	watch: {
		'jieshao': function(val){
			console.log('jieshao==',val)
		}
	},
	props: {
		jieshao: {
			type: String,
			default: function () {
				return '';
			}
		}
	},
	created(){
		
	},
	methods: {
		
	}
}
</script>
<style scoped>
	/deep/.rich-wrap img{
		width: 80px !important;
	}
</style>